import { useGetCurrentUserQuery } from '@carboncopyco/data';
import { DownOutlineIcon } from '@carboncopyco/icons';
import type { Role } from '@carboncopyco/types';
import { Button, Dropdown, DropdownItem } from '@carboncopyco/ui';
import { useDemoAnalytics } from '@carboncopyco/utils';
import NiceModal from '@ebay/nice-modal-react';
import { useState } from 'react';
import { DemoLinkModal } from '../../DemoLinkModal';
import { ShareDemoFlow } from '../../Share';
import { useDemoLinks } from './DemoPageContext';

export const DemoShareDropdownMenu = ({
  demoId,
  organizationId,
  workspaceId,
  location,
  goToLinksTab,
  readOnly,
}: {
  goToLinksTab?: (demoId: string) => void;
  demoId?: string;
  organizationId: string;
  workspaceId: string;
  location?: string;
  readOnly?: boolean;
}) => {
  const { addItem } = useDemoLinks();
  const [openDemoLinkModal, setOpenDemoLinkModal] = useState(false);
  const { trackDemoClickShareInternally, trackDemoClickShare } =
    useDemoAnalytics(location);
  const { data: userData } = useGetCurrentUserQuery();
  const userRole: Role = userData?.user?.roles?.[organizationId];

  return (
    <>
      <Dropdown
        triggerElement={
          <Button
            secondary
            rightIcon={<DownOutlineIcon />}
            label="Share"
          />
        }
      >
        <DropdownItem
          disabled={readOnly}
          label="Share internally"
          onClick={() => {
            trackDemoClickShareInternally();
            setOpenDemoLinkModal(true);
          }}
        />
        <DropdownItem
          label="Share externally"
          onClick={() => {
            trackDemoClickShare();
            NiceModal.show(ShareDemoFlow, {
              workspaceId,
              demoId: Number(demoId),
              goToShares: () => goToLinksTab?.(demoId),
              onCreateSuccess: addItem,
            });
          }}
        />
      </Dropdown>
      {openDemoLinkModal && (
        <DemoLinkModal
          workspaceId={workspaceId}
          assetId={demoId}
          assetType="demo"
          organizationId={organizationId}
          isOpen={openDemoLinkModal}
          onClose={() => setOpenDemoLinkModal(false)}
          role={userRole}
        />
      )}
    </>
  );
};
